
import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import Moment from 'moment-timezone';
import { Link } from 'react-router-dom';
import qs from 'qs';

import InfiniteScroll from '@/components/Grid/components/Table/InfiniteScroll'
import { ReportBody } from '@/components/reports/body'
import { formatDate } from '@/utils';
import DefaultGrid from 'components/table/grid/DefaultGrid';
import optoutStore from 'modules/report/stores/optout';
import publisherStore from 'modules/offer/stores/publisher'
import { TODAY } from 'components/DateRangeButton';

import Header from './components/Header'
import Configure from './components/Configure'
import app from 'stores/app'

const propTypes = {
  match: PropTypes.object
};

export default class Optouts extends DefaultGrid {
  constructor(props) {
    super(props)
    this.state.options.sortField = 'optoutdate'
    this.state.options.sortOrder = 'desc'
    this.state.startDate = Moment(TODAY.start)
    this.state.endDate = Moment(TODAY.end)
    this.state.timezone = app.timezone
  }

  entityName = 'Optout'
  entityNamePlural = 'Optouts'
  store = optoutStore
  publishers = {}

  emptyFormatter = cell => cell || '--'
  emailFormatter = email => this.emptyFormatter(email && <Link className='twy-text-accent' to={`/reports/inquiry?${qs.stringify({ email })}`}>{email}</Link>)
  publisherName = cell => this.emptyFormatter(cell && `${cell}${this.publishers[cell] && ` - ${this.publishers[cell]}` || ''}` || cell)

  loadData = () => {
    this.store.list({ ...this.query, startDate: Moment(this.state.startDate).format(), endDate: Moment(this.state.endDate).format() }).then(() => {
      this.setState({})
    });
    this.setState({})
  }

  columns = [
    {
      dataField: 'publisherId',
      formatter: this.publisherName,
      sort: true,
      text: 'Publisher ID'
    }, 
    {
      dataField: 'email',
      formatter: this.emailFormatter,
      sort: true,
      text: 'Email',
    }, {
      dataField: 'userId',
      sort: true,
      text: 'User',
    }, {
      dataField: 'ipaddress',
      sort: true,
      text: 'IP Address',
    }, {
      dataField: 'optoutdate',
      sort: true,
      formatter: cell => cell ? formatDate(Moment(cell).tz(this.state.timezone), 'MMM DD, YYYY - hh:mm A') : '--',
      text: 'Optout Date',
    },
  ]

  loadParams = qs => {
    qs = new URLSearchParams(qs)
    for (let [pkey, pvalue] of qs.entries()) {
      if (pkey.match(/search\w+date/ig))
        pkey = pkey.replace(/search(\w)(\w+)/, (_, _1, _2) => _1.toLowerCase() + _2)

      this.state[pkey] = pvalue === 'null' ? null : pvalue
    }
    if (qs.has('optoutdate')) {
      this.state.startDate = qs.get('optoutdate')
      this.state.endDate = qs.get('optoutdate')
    }
    this.convertTimezone(this.state)
  }

  componentWillReceiveProps(props) {
    props.location.search && this.loadParams(props.location.search)
    super.componentWillReceiveProps(props)
  }

  componentWillMount() {
    this.props.location.search && this.loadParams(this.props.location.search)
    super.componentWillMount()
  }

  loadPublishers = async () => {
    return publisherStore.all().then((res) => {
      this.publishers = res.data.reduce((p, c) => {
        p[c.id] = c.name
        return p
      }, {})
      return res
    })
  }

  convertTimezone = dates => {
    if (dates.startDate && dates.endDate) {
      const startDate = Moment.tz(typeof dates.startDate === 'string' ? dates.startDate : dates.startDate.format('YYYY-MM-DD'), this.state.timezone).startOf('day')
      const endDate = Moment.tz(typeof dates.endDate === 'string' ? dates.endDate : dates.endDate.format('YYYY-MM-DD'), this.state.timezone).endOf('day')
      
      dates.searchStartDate = startDate.format('YYYY-MM-DD')
      dates.startDate = startDate.format()
      
      dates.searchEndDate = endDate.format('YYYY-MM-DD')
      dates.endDate = endDate.format()
    }
  }

  handleChange = dates => {
    this.setState(dates, this.loadData)
  }

  renderScroll() {
    return <div className='flex w-full justify-center items-center h-14'>
      {this.store.hasNextPage && <InfiniteScroll onVisit={this.handleNextPage} hasMore={this.store.hasNextPage} />}
    </div>
  }

  render() {
    const { startDate, endDate } = this.state
    return <>
      <Helmet title={this.entityNamePlural} />
      <Header
        title={this.entityName}
        onChange={this.handleChange}
        dates={{ startDate, endDate }}
        sync={this.loadData}
        isLoading={optoutStore.isLoading}
      >
        <Configure
          onChange={this.handleChangeFilters}
          onChangeSearch={this.handleSearch}
          loadPublishers={this.loadPublishers}
          filters={this.state}
        />
      </Header>
      <ReportBody loading={optoutStore.isLoading}>
        {this.renderTable()}
        {this.renderScroll()}
      </ReportBody>
    </>
  }
}

Optouts.propTypes = propTypes
